import React, { useState, useEffect } from "react";
import { Modal, Button, List, Image, Typography, Divider, message } from "antd";
import { ObtenerValoresCampo } from "../../../services/formularioUsuarios";
import { ObtenerUsuario } from "../../../services/usuarios";

const { Text } = Typography;

const VerValoresModal = ({ isModalOpen, setIsModalOpen, selectedCampo }) => {
  const [valoresCampo, setValoresCampo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState({}); // { userId: { first_name, last_name } }

  const fetchUserData = async (userId) => {
    try {
      const response = await ObtenerUsuario(userId);
      // La respuesta es un array, tomamos el primer elemento si existe
      return response && response.length > 0 ? response[0] : null;
    } catch (error) {
      console.error(`Error obteniendo usuario ${userId}:`, error);
      return null;
    }
  };

  useEffect(() => {
    if (isModalOpen && selectedCampo) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const valores = await ObtenerValoresCampo();
          const valoresFiltrados = valores.filter(
            (valor) => valor.campos_users === selectedCampo.id
          );

          // Obtener usuarios en paralelo
          const usuariosMap = {};
          await Promise.all(
            valoresFiltrados.map(async (valor) => {
              if (valor.user) {
                usuariosMap[valor.user] = await fetchUserData(valor.user);
              }
            })
          );

          setUsuarios(usuariosMap);
          setValoresCampo(valoresFiltrados);
        } catch (error) {
          console.error("Error al obtener datos:", error);
          message.error("Error al cargar los valores");
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [isModalOpen, selectedCampo]);

  const renderValor = (valor) => {
    const isImage = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(valor.valor);
    const usuario = usuarios[valor.user];

    return (
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8 }}>
          <Text strong>Usuario:</Text> {usuario ? `${usuario.first_name} ${usuario.last_name}` : `ID: ${valor.user}`}
        </div>
        <div>
          <Text strong>Valor:</Text>{" "}
          {isImage ? (
            <Image
              width={200}
              src={`${process.env.REACT_APP_URL_DIRECTUS}/assets/${valor.valor}`}
              alt="Imagen subida"
              style={{ marginTop: 8 }}
            />
          ) : (
            valor.valor
          )}
        </div>
        <Divider style={{ margin: "12px 0" }} />
      </div>
    );
  };

  return (
    <Modal
      title={`Valores del Campo: ${selectedCampo?.campo}`}
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={[
        <Button key="close" onClick={() => setIsModalOpen(false)}>
          Cerrar
        </Button>,
      ]}
      width={800}
    >
      {selectedCampo && (
        <div>
          <div style={{ marginBottom: 16 }}>
            <p>
              <strong>Tipo:</strong> {selectedCampo.tipo_campo}
            </p>
            {selectedCampo.opciones && (
              <p>
                <strong>Opciones:</strong>{" "}
                {selectedCampo.opciones.replace(/[{"}]/g, "").split(",").join(", ")}
              </p>
            )}
            {selectedCampo.roles?.length > 0 && (
              <p>
                <strong>Roles:</strong>{" "}
                {selectedCampo.roles.map((role) => role.directus_roles_id.name).join(", ")}
              </p>
            )}
          </div>

          <h4>Valores Asociados:</h4>
          {loading ? (
            <p>Cargando valores...</p>
          ) : valoresCampo.length === 0 ? (
            <p>No hay valores asociados</p>
          ) : (
            <List
              dataSource={valoresCampo}
              renderItem={renderValor}
              style={{ maxHeight: 400, overflowY: "auto" }}
            />
          )}
        </div>
      )}
    </Modal>
  );
};

export default VerValoresModal; 